import { HeatConfig } from "graphql/generated/types";

type CurrentHeatConfig = Pick<HeatConfig, "calculator" | "categories" | "categoryGroups" | "isTeams" | "hasStartlist" | "runBased">;

export const isHeatSupported = (currentHeatsConfig: CurrentHeatConfig[] | undefined) => !!currentHeatsConfig?.every(config => config
    && !["placing", "timing"].some(calculator => calculator === config.calculator)
    && !config.categories
    && !config.categoryGroups
    && !config.isTeams
    && !config.hasStartlist
    && !config.runBased
);
